/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { AngularFireAction, DatabaseSnapshot } from '@angular/fire/compat/database';

import { ProjectMember, ProjectMemberFields } from '@touchplan/common';
import { FancyFirebaseSplitDataList } from '../generics/FancyFirebaseSplitDataList';
import { LocalAction, LocalSnapshot } from '../base/LocalSnapshot';
import { FancyAction } from '../base/FancyAction';
import { AngularLandConnection, RefOrObservable } from '../base/interfaces';
import { IFancyIdJoin } from '../base/FancyIdJoin';
import { DefaultActionHandlers } from '../generics/DefaultActionHandlers';
import { DefaultActionTypes } from '../generics/DefaultActionTypes';
import { DefaultSplitDataRenderType } from '@touchplan/common';
export class ProjectMemberList
	extends FancyFirebaseSplitDataList<ProjectMemberFields, DefaultSplitDataRenderType, ProjectMember>
	implements IFancyIdJoin
{
	protected defaultActionsHandlers: DefaultActionHandlers<ProjectMember, FancyAction, this> =
		new DefaultActionHandlers(this, [DefaultActionTypes.addItem, DefaultActionTypes.removeItem]);

	constructor(angularLand: AngularLandConnection, path: RefOrObservable, fancyJoins?: any) {
		super(angularLand, path, fancyJoins);
	}

	public $$added(action: LocalAction<LocalSnapshot<any>>) {
		const projectMember = new ProjectMember(action.payload.key);
		projectMember.databaseUpdate(action.payload.val());
		return projectMember;
	}
	public $$updated(child: ProjectMember, action: AngularFireAction<DatabaseSnapshot<any>>) {
		super.$$updated(child, action);
	}

	//put in interface so you can explicitly say you're doing this
	public applyJoinData(baseKey: string, child: ProjectMember, otherChild: any) {
		switch (baseKey) {
			case 'roleId':
				child.view.role = otherChild ? otherChild : null;
				break;
			case 'userId':
				child.view.user = otherChild ? otherChild : null;
				break;
			default:
				break;
		}
	}
	public getDataForKey(baseKey: string, child: ProjectMember) {
		return child.view[baseKey];
	}
}
